/**
* Marquee Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the Marquee Cards component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

( function( app ) {
  const COMPONENT = {

    className: 'marquee-cards',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.marquee-cards' ).each( function( key, component ) {
        const topSplide = new Splide( $( component ).find( '.splide--marquee-cards--top' )[0], {
          type: 'loop',
          pagination: false,
          arrows: false,
          gap: '32px',
          autoWidth: true,
          autoScroll: {
            speed: 0.5,
          },
        } );
        topSplide.mount( {AutoScroll} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'marquee-cards', COMPONENT );
} )( app );
